module.exports = __webpack_public_path__ + "img/home-title.9a27d7a1.png";